import { render, staticRenderFns } from "./LightBoxReset.vue?vue&type=template&id=8a3c4202"
import script from "./LightBoxReset?vue&type=script&lang=ts&external"
export * from "./LightBoxReset?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports